import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper";

function Screens() {
  return (
    <div id="screens" className="slider">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="slider-container">
              <div className="image-slider">
                {/* <div className="swiper-wrapper"> */}
                <Swiper
                  slidesPerView={5}
                  spaceBetween={30}
                  slidesPerGroup={5}
                  loop={true}
                  loopFillGroupWithBlank={true}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  modules={[Pagination, Navigation]}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/screen-8.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/screen-5.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/screen-6.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/screen-7.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <a
                      href="images/screenshot-5.jpg"
                      className="popup-link"
                      data-effect="fadeIn"
                    >
                      <img
                        className="img-fluid"
                        src="images/screen-4.png"
                        alt="alternative"
                      />
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/female-profile.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <img
                      className="img-fluid"
                      src="images/settings.png"
                      alt="alternative"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <a
                      href="images/screenshot-1.jpg"
                      className="popup-link"
                      data-effect="fadeIn"
                    >
                      <img
                        className="img-fluid"
                        src="images/screen-9.png"
                        alt="alternative"
                      />
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <a
                      href="images/screenshot-4.jpg"
                      className="popup-link"
                      data-effect="fadeIn"
                    >
                      <img
                        className="img-fluid"
                        src="images/screen-3.png"
                        alt="alternative"
                      />
                    </a>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <a
                      href="images/screenshot-3.jpg"
                      className="popup-link"
                      data-effect="fadeIn"
                    >
                      <img
                        className="img-fluid"
                        src="images/screen-2.png"
                        alt="alternative"
                      />
                    </a>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div
                className="swiper-button-next"
                style={{ color: "red" }}
              ></div>
              <div
                className="swiper-button-prev"
                style={{ color: "red" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Screens;
